import styled from '@emotion/styled';

export const TextContainer = styled.div`
  font-size: 0.8rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;
